module.exports = {
  language: {
    name: '简体中文',
    title: '选择语言',
    subList: [
      {
        name: 'English',
        link: 'en',
      },
      // {
      //   name: '简体中文',
      //   link: 'zh',
      // },
      {
          name: '繁體中文',
          link: 'tw',
      },
      {
        name: '日本語',
        link: 'jp',
      },
      {
        name: '한국어',
        link: 'kr',
      },
      {
        name: 'ไทย',
        link: 'th',
      },
      {
        name: 'Tiếng Việt',
        link: 'vn',
      },
      {
        name: 'Español',
        link: 'es',
      },
    ]
  },
  "user":{//내
    "wdtd": "내 팀",
    "wdyj": "내 공연",
    "ren": "사람",
  },
  "kjsy": {
    "title": "수익",
    "fxsy": "수익 공유",
    "zjlsl": "총 보상 금액:",
    "jl": "보상",
    "sj": "날짜",
    "sl": "수량",
    "sm": "설명"
  },
  "pay":{//구매
    "title": '마이닝 머신 구입',
    gmsl: '구매 수량',
    zf: '결제',
    kyye: '사용 가능한 잔액',
    kyyebz: '사용 가능한 잔액 부족',
    bztbtips: '입력된 인출 금액이 이 통화의 최소 인출 요구 사항보다 적습니다.',
    bztbtips2: '출금 금액은 최소 출금 금액보다 낮을 수 없습니다.',
    qsrjymm: '거래 비밀번호 6자리를 입력하세요',
    wxts: '알림',
  },
  "chongbi":{
    "title": '보증금',
    lianmc: '체인 유형',
    scl: '독점 체인 생성',
    sy: '개인 키',
    ewm: 'QR 코드',
    bcewm: 'QR코드 저장',
    cbdz: '입금 주소',
    fz: '복사',
    sl: '입금액',
    qsrsl: '입금액을 입력하세요',
    sjczje: '실제 충전량',
    qsrsjczje: '실제 충전 금액을 입력하세요',
    pzms: '인증서 설명',
    qsrms: '설명을 입력하세요',
    hxz: '해시값',
    qsrhxz: '해시 값을 입력하세요',
    pztp: '바우처 이미지',
    qscpztp: '증명서 사진을 올려주세요',
    fzcg: '복사 성공',
    yhkcz: '은행 카드 충전',
    usdtcz: 'USDT 충전',
    btccz: '비트코인 충전',
    xzbz: '통화 선택',
    sure: '확인',
    ck: '보기',
    "tips1": "현재 통화가 아닌 자산들은 위 주소로 충전하지 말아 주십시오. 그렇지 않으면 해당 자산을 조회할 수 없습니다",
    "tips2": "1. 지갑/플랫폼 호환성: 즉, 네트워크가 지원되며 대상 플랫폼이 출금 네트워크를 지원하지 않는 경우 자산을 검색할 수 없습니다.",
    "tips3": "2. 귀하의 탑업 네트워크와 대상 플랫폼이 동일하며, 대상 주소를 이더리움 네트워크로 선택했지만 탑업이 TRC20 스마트체인을 선택한 경우 디지털 자산을 검색하지 못할 수 있습니다.",
    "tips4": "3. 충전하기 전에 주소와 금액이 정확한지 확인하십시오.",
    "tips5": "알림: 블록 네트워크의 익명성과 개인 정보 보호로 인해 잘못된 정보를 입력하면 해당 자산을 잃게 됩니다. 충전 주소와 수량을 잘 확인하세요."
  },
  usdttb:{
    title: '코인 출금',
    lmc: '체인 종류',
    xzl: '체인 선택',
    xztbdz: '출금 주소 선택',
    qsrtbdz: '출금 주소를 입력하세요',
    tbdz: '출금 주소',
    qsrdz: '주소를 입력하세요',
    tbsl: '출금금액',
    tbsl2: '출금금액:',
    qsrtbsl: '출금 금액을 입력하세요',
    sjtxje: '실제 인출 금액',
    qsrsjtxje: '실제 인출 금액을 입력하세요',
    dzje:'계정 금액',
    jymm: '거래 비밀번호',
    qsrjymm: '거래 비밀번호를 입력하세요',
    sxf: '취급 수수료',
    qsrsxf: '수수료를 입력하세요',
    dzsl: '계좌 금액',
    dzsl2: '받은 계좌 금액:',
    qsrdzsl: '계좌 금액을 입력하세요',
    wxts: '알림:',
    mrzdtxcs: '매회 최소 인출 금액:',
    hxxf: '소비 필요',
    cktx: '출금만 가능',
    ci: '시간',
    wddtxyq: '출금 요건이 충족되지 않음',
    tjcg: '제출에 성공했습니다. 검토를 기다려 주세요.',
    tips: '자신의 컴퓨팅 파워가 1T 이상(경험 ​​마이닝 머신 컴퓨팅 파워 제외) 또는 우산 아래 컴퓨팅 파워가 50T 이상인 경우에만 코인을 인출할 수 있습니다. ',
    dz: '주소',
    qd: '확인',
    "zdtb": "최소 출금"
  },
  "kefu": {
    title:'고객 서비스에 문의하기',
    zxkf: '고객 서비스',
    fzcg:'복사 성공'
  },
  xgdlmm:{//로그인 비밀번호 수정
    title:'로그인 비밀번호 변경',
    t1:'현재 로그인 비밀번호',
    t2:'현재 로그인 비밀번호를 입력하세요',
    t3:'새 비밀번호',
    t4:'6~16개의 숫자와 영문을 입력하세요.',
    t5:'비밀번호 확인',
    t6:'6~16개의 숫자와 영문을 입력하세요.',
    t7:'확인',
    t8: '암호가 확인 암호와 일치하지 않습니다'
  },
  sztxmm:{//출금 비밀번호 설정
    title:'거래 비밀번호 변경',
    wjtkmm: '거래 비밀번호 분실',
    qsrjdlmm: '현재 거래 비밀번호를 입력하세요',
    ko: '계정',
    qsryxhzsj: '이메일 주소나 휴대폰을 입력하세요',
    t1:'현재 거래 비밀번호',
    t2:'새 거래 비밀번호',
    t3:'거래 비밀번호 6자리를 입력해주세요',
    t4:'비밀번호 확인',
    t5: '거래 비밀번호를 잊으셨나요? ',
    t6:'확인',
    t7: '암호가 확인 암호와 일치하지 않습니다',
    t8:'거래 비밀번호',
    yzm: '인증 코드',
    qsryzm: '인증 코드를 입력하세요',
    hqyzm: '확인 코드 받기'
  },
  "record": {
    cbjl: '입금내역',
    tbjl: '출금기록',
    status:['검토되지 않음','통과됨','거부됨'],
    bhly: '거절 사유',
    ldz: '주소:',
    cjsj: '생성 시간:',
    zzsj: '전송 시간:',
    czl: '충전 체인:',
    zrl: '전송 체인:',
    jyhx: '트랜잭션 해시:'
  },
  yqm: {
    wdyqlj: '내 초대 링크',
    wdyqm: '내 초대 코드',
    schbyq: '포스터 초대장 생성',
    bctp: '사진 저장',
    qx: '취소',
    fx: '공유',
    yqm: '초대 코드 복사',
    bcewmdxc: 'QR 코드를 앨범에 저장',
    bcbd: '로컬 저장'
  },
  "wdtd": {
    "title": '나의 팀',
    td: '팀',
    yqhy: '친구 초대',
    ren: '사람',
    wdtdzrs: '내 팀의 총 수',
    UID: 'UID:',
    zh: '계정:',
    tdrs: '팀 규모:',
    zcsj: '등록 날짜:'
  },
  "wdyj": {
    "title": '마이 퍼포먼스',
    wdyd: '나의 세대',
    dyj: '성능',
    tdzyj: '팀 전체 실적',
    UID: 'UID:',
    tdrs: '팀 규모:',
    yj: '성능:'
  },
  "zc": {
    "title": '자산',
    zzczh: '총 자산 등가',
    dh: '교환',
    yczc: '0으로 숨겨진 자산',
    xj: '현재 가격',
    zh: '변환됨',
    zcmx: '자산 세부정보',
  },
  "duihuang": {
    "title": '교환',
    hl: '환율',
    zf: '결제',
    qbdh: '모두 교환',
    ky: '사용 가능',
    dd: '받기',
    ljdh: '지금 교환',
    cont: '환율 변경, 실제 수령 금액에 따름',
    yebz: '잔고 부족',
    ksslbz: '수량이 부족합니다',
    qtxje: '수량을 입력하세요',
    dhcg: '교환 성공',
    mrcg: '구매 성공',
    mccg: '성공적으로 판매됨',
    wtcg: '위임 성공',
    ts: '프롬프트',
    btcmTips: '스마트 컨트랙트 설정에 따라 GDCC 거래소 USDT가 2023년 8월 8일부터 시작됩니다. ',
    qx: '취소'
  },
  "sign": {
    "title": '코인을 받으려면 로그인하세요',
    "title2": '일일 로그인 보상',
    "title3": '로그인 보상',
    "qd": '로그인',
    "yqd": '로그인됨',
    "hdgz": '이벤트 규칙',
    "qdjl": '체크인 기록',
    "qdcg": '로그인 성공'
  },
  "langNew": {
    "wd": "내",
    "jd": "빌리는 중",
    "jghy": "선물",
    "xbsg": "싱가포르 통화 구매",
    "sylx": "혜택 유형",
    "syts": "수익 일수: ",
    "rsy": "일일 수입: ",
    "rsy2": "일일 수입",
    "yjdts": "빌린 일수: ",
    "jdsy": "대출 수입: ",
    "jdsy2": "대출 수입",
    "jdrq": "대출 날짜: ",
    "qdsy": "로그인 혜택",
    "tgsy": "프로모션 혜택",
    "sybl": "이익률",
    "sybl2": "이익률:",
    "ljcy": "지금 가입하세요",
    "zsy": "총 수입",
    "jdrz": "링크 노드",
    "jiedian": "노드",
    "qsrje": "노드를 입력하세요",
    "xyb": "다음",
    "zhye": "계정 잔액",
    "dzye": "주소 잔액",
    "zhyezh": "계정 잔액(동등)",
    "zq": "기간: ",
    "zq2": "마침표",
    "jdsl": "대출 금액",
    "yxbd": "이메일 확인",
    "qsryxzh": "이메일 계정을 입력하세요",
    "yxgz": "입력한 이메일 주소가 규칙을 준수하지 않습니다",
    "jxz": "진행 중",
    "ywc": "완료됨",
    "day": "일",
    "jg": "가격: ",
    "zwsj": "데이터 없음~",
    "wyjb": "빌려",
    "fxjl": "보상 공유",
    "aqsz": "보안 설정",
    "wded": "나의 2세대",
    "wdsd": "나의 3세대",
    "dbxe": "단일 거래 한도",
    "tjdd": "주문 제출",
    "tqsh": "상환 철회: ",
    "shhuhui": "구원",
    "ljdz": "링크 주소",
    "yyqh": "언어 전환",
    "zxkf": "고객 서비스",
    "syl": "매일 반품",
    "zhuanbi": "코인을 획득하세요",
    "zbsy": "외화 수입을 얻으세요",
    "mc": "이름",
    "zxj": "최신 가격",
    "zfb": "상승 목록",
    "shouye": "홈페이지",
    "gg": "공지사항",
    "rzz": "인증 중",
    "yrz": "인증됨",
    "rzsb": "인증에 실패했습니다. 다시 인증하세요",
    "cxrz": "재인증",
    "jymmts": "거래 비밀번호를 설정하려면 보안 설정으로 이동하세요."
  },
  "xbsg":{
    "title": "동전 구매",
    "wdsg": "세부",
    "scts": "락업일: ",
    "sy": "남은",
    "ljsg": "지금 구독",
    "ysk": "매진",
    "xzjdy": "지금 구독",
    "dy": "구독하다",
    "fxjg": "발행 가격",
    "fxl": "순환",
    "ssrq": "상장일",
    "yxqx": "유효 기간",
    "qsrsl": "수량을 입력해주세요",
    "syl": "남은",
    "sgrq": "구독 날짜",
    "sgsl": "양",
    "bz": "동전",
    "yebz": "USDT 잔액 부족",
    "tgsl": "패스 수량",
    "shz": "검토 중",
    "wtg": "실패",
    "ytg": "통과"
  },
  "wydb":{
    "title": "빌리다",
    "db": "빌리다",
    "dbz": "빌리다",
    "jl": "기록",
    "jdzq": "기간(일)",
    "qhk": "갚다",
    "ljdb": "누적",
    "dhkbs" :"지불 보류",
    "jkje": "대출금액",
    "qsrje": "수량을 입력해주세요",
    "rll": "일일 이자율",
    "hkfs": "반환",
    "dqych": "만료됨",
    "lx": "관심",
    "fkjg": "대주",
    "tpsc": "신용대출(이미지 업로드)",
    "fwxx": "주택정보",
    "srzm": "소득 증명(고용 관계)",
    "yhmx": "은행 명세서",
    "zjz": "신분증 사진",
    "yd": "읽고 동의했습니다",
    "xy": "대출 계약 신청",
    "sqdb": "대출 체인 신청",
    "gb": "폐쇄",
    "qd": "확인",
    "ts": "대출 계약 신청을 확인하십시오",
    "dbjl": "기록",
    "hkhth": "주문 코드",
    "wsh": "미검토",
    "yfk": "대출",
    "sqrq": "신청 시간",
    "zq": "주기",
    "dbsl": "갈비뼈의 수",
    "zhke": "총 지불",
    "yhkxq": "상환내역",
    "bqyhk": "현재 기간에 상환 가능(USDT)",
    "hktips": "잔액이 충분한지 확인하시고, 잔액이 부족할 경우 충전 후 상환하시기 바랍니다.",
    "bj": "주요한",
    "jie": "빌리다",
    "ljhk": "즉시 상환",
    "qcz": "입금하기",
    "yebzqxcz": "잔액이 부족합니다. 먼저 충전한 다음 상환하세요.",
    "znj": "연체료",
    "yqts": "연체일수"
  },
  "hkxq":{
    "dd":"주문하다",
    "fzhkdz":"상환 주소 복사",
    "hkxq": "상환내역",
    "zlx": "총 이자",
    "zhk": "총 상환액",
    "hkjg": "상환 기관",
    "qschkpz": "상환 증명서를 업로드하십시오",
    "hkpz": "상환 증명서"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "보류 중 주문",
    "cj": "딜",
    "jj": "정보",
    "sj": "시간",
    "fx": "방향",
    "jg": "가격",
    "sl": "금액",
    "mr": "매입",
    "mc": "매도",
    "mp": "입찰",
    "sp": "매도 중",
    "slb": "금액",
    "fhsj": "배포 시간",
    "fhsl": "발행 번호",
    "bps": "백서",
    "gw": "공식 웹사이트",
    "yue": "월",
    "ft": "측면 사진",
    "zt": "메인 사진",
    "sdt": "깊이",
    "zx": "선택 사항",
    "djck": "보려면 클릭"
  },
  "jghy": {
    "jghy": "선물",
    "yxhy": "영구 계약",
    "mz": "롱 매입",
    "md": "쇼트 매도",
    "gmj": "구매가",
    "jsj": "정산가",
    "xj": "현재 가격",
    "fx": "방향",
    "sl": "금액",
    "jgsj": "배송 시간",
    "gb": "클로즈",
    "jxxd": "계속 주문",
    "cclb": "주문 목록",
    "zc": "현재",
    "lscc": "이력",
    "qblx": "모든 유형",
    "yk": "수익 및 손실",
    "ddqr": "주문 확인",
    "dqsj": "만료 시간",
    "jssj": "배송 시간",
    "sy": "수익",
    "tzje": "투자 가격",
    "zdje": "최저 가격 0",
    "kyye": "균형",
    "kyye2": "균형: ",
    "sxf": "요금: ",
    "sxfl": "요금",
    "jypz": "이름",
    "jyfx": "방향",
    "qrxd": "확인",
    "dqye": "현재 잔고"
  },
  "zhjl": {
    "title": "자산 내역",
    "cbtb": "예치 및 인출",
    "jymx": "거래 내역",
    "tgyj": "프로모션 커미션",
    "wwc": "취소됨",
    "ywc": "완료됨"
  },
  "tipsNew":{
    "wjmmts": "인증 코드로 비밀번호 복구",
    "qscpztp": "바우처 이미지 업로드",
    "emailgsts": "유효한 이메일을 입력하십시오",
    "telgsts": "휴대폰 번호가 잘못되었습니다",
    "lcmmbyz": "비밀번호를 확인해주세요",
    "zdsl": "최소 수량 ",
    "sldydy": "다음보다 크거나 같은 수량",
    "zxtzsl": "최소 수량 ",
    "ddz": "기다리는",
    "xs": "시간",
    "min": "최소 금액 ",
    "max": "최대 금액 ",
    "yebz": "잔액 불충분",
    "qsrss": "로트를 입력하세요",
    "zdss": "최소 부지",
    "yjj": "거부",
    "shz": "구원",
    "zwkfcz": "이 통화는 아직 충전할 수 없습니다.",
    "jiaoge": "배달",
    "zhang": "일어나다",
    "die": "죽다",
  },
  "assets": {
    "total": "자산 전환",
    "avaiable": "사용 가능",
    "conversion": "변환",
    "canuse": "사용 가능",
    "yczc": "0으로 숨겨진 자산"
  },
  "status": {
    "statusText": ['실패','대기 중','성공'],
  },
  "langNew2":{
    "zczgz": "총 자산",
    "hgx": "규정 준수",
    "yszc": "개인정보 보호정책",
    "gywm": "회사 소개",
    "zb": "AI 정량화",
    "mnjy": "시뮬레이션 거래",
    "xbzq": "싱가포르 통화 존",
    "flzq": "보상 허브",
    "cjmnzhcg": "데모 계정을 성공적으로 생성했습니다!",
    "wdzh": "내 계정",
    "yymnzhts": "이미 가상 계정이 있습니다. 다시 등록하지 마세요.",
    "tcmnzh": "데모 계정 종료",
    "mnzhgz": "데모 계정 평가",
    "mnzh": "데모 계정",
    "ljdzsb": "주소에 연결하지 못했습니다.",
    "ysq": "인정 받은"
  },
  "c2c":{
    "bt": "P2P",
    "bt2": "P2P 결제 서비스",
    "cjdd": "주문 생성",
    "mblc": "명목 화폐 예금",
    "cjydd": "선주문 만들기",
    "xmjfk": "판매자에게 지불",
    "tqhb": "디지털 화폐를 인출하세요",
    "ddzt": "주문 상태",
    "wdys": "우리의 장점",
    "c1": "원하는 가격으로 거래하세요",
    "c2": "원하는 가격으로 암호화폐를 자유롭게 사고 팔 수 있습니다. 기존 제안에서 사고 팔거나 거래 광고를 만들어 이상적인 가격을 설정하세요.",
    "c3": "낮은 거래 수수료",
    "c4": "P2C(Peer-to-Peer) 거래를 통해 판매자는 은행 송금, 현금 등 700가지 이상의 결제 방법을 통해 암호화폐를 사고 파는 등 판매자가 원하는 결제 방법을 투명하게 자유롭게 정의할 수 있습니다.",
    "c5": "여러 결제 방법",
    "c6": "P2C(Peer-to-Peer) 거래를 통해 판매자는 원하는 결제 방법을 자유롭게 정의할 수 있습니다. 은행 송금, 현금 등 700가지 이상의 결제 방법으로 암호화폐를 사고 팔 수 있습니다.",
    "wpp": "일치하지 않음",
    "ypp": "일치함",
    "ysx": "만료됨",
    "ddh": "주문 번호",
    "mrje": "구매 금액",
    "mrbz": "화폐 구매",
    "nssdgj": "국가",
    "qsrnssdgj": "국가를 입력하세요",
    "fkrxm": "지급인 이름",
    "qsrfkrxm": "지불인의 이름을 입력하세요",
    "yx": "이메일",
    "qsryx": "이메일 주소를 입력하세요",
    "mmbz": "구매 유형",
    "qxzmmbz": "구매 유형을 선택하세요",
    "qxz": "선택하세요",
    "fkfs": "결제 방법",
    "qtxfkfs": "결제 방법을 입력하세요",
    "zh": "계정",
    "fb": "결제 통화 유형",
    "qtxfb": "결제 통화 유형을 입력하세요",
    "ngmdje": "구매 금액",
    "qsrje": "금액을 입력하세요",
    "wxts": "알림:",
    "dsh": "검토 예정",
    "ygq": "만료됨",
    "jcwdwt": "P2P 소개",
    "tjpz": "바우처 제출",
    "ckje": "일치 금액",
    "qsrckje": "일치하는 금액을 입력하세요",
    "tjzzfb": "사본 전송",
    "tjjzzm": "신분증(앞면)",
    "tjjzfm": "신분증 (뒷면)",
    "psts1": "촬영 시 다음 사항에 주의하세요",
    "psts2": "그림의 테두리가 완성되고 글꼴이 선명하며 밝기가 균일하다는 점에 유의하세요.",
    "psts3": "이름과 일치하지 않는 신분증 사진을 업로드하지 마세요",
    "qsczzfb": "이체 사본을 업로드하세요",
    "qscjzzm": "운전면허증 앞면을 업로드해 주세요",
    "qscjzfm": "운전면허증 뒷면을 업로드해 주세요",
    "tj": "제출",
    "je": " 제한 범위",
    "ljtg": "주문하기",
    "sp": "DeFi 이해",
    "xq": "세부정보",
    "lxkfppdd": "주문과 일치하려면 고객 서비스에 문의하세요",
    "szgj": "국가",
    "qsrszgj": "국가를 입력하세요",
    "fkyhmc": "결제 은행 이름",
    "qsrfkyhmc": "결제 은행 이름을 입력하세요",
    "dianhui": "전신 송금/국제 전신 송금",
    "ccsr": "여기에 입력하세요"
  },
  "xyf":{
    "title": "신용 점수",
    "pgsj": "평가 시간"
  },
  "bbjy": {
    "mr": "매입",
    "mc": "매도",
    "mai": "매입",
    "sell": "매도",
    "xj": "한계",
    "sj": "시장 가격",
    "pk": "핸디캡",
    "jg": "가격",
    "sl": "금액",
    "mrl": "매입량",
    "ss": "금액",
    "mcl": "매도량",
    "ky": "이용 가능",
    "km": "이용 가능",
    "ksell": "판매 가능",
    "jye": "회전율",
    "dqwt": "대기 주문",
    "lswt": "커미션 이력",
    "jj": "정보",
    "wtzl": "총",
    "wtjg": "커미션 가격",
    "ycjl": "완료된 거래 볼륨",
    "cjjj": "평균 거래 가격",
    "cd": "인출",
    "xd": "주문",
    "ywc": "완료됨",
    "ycd": "인출됨",
    "wqcj": "거래 완료",
    "zx": "선택 사항",
    "scjg": "시장 가격",
    "fhsj": "배포 시간",
    "fhsl": "발행 번호",
    "bps": "백서",
    "gw": "공식 웹사이트",
    "qx": "취소",
    "bbjy": "교환"
  },
  "hyjy": {
    "mai": "매입",
    "sell": "매도",
    "kc": "오픈 포지션",
    "pc": "클로즈",
    "cc": "포지션",
    "kp": "클로즈",
    "kpc": "클로즈 쇼트",
    "kcc": "포지션",
    "kkd": "오픈 롱",
    "kpd": "롱 클로즈",
    "kkk": "오픈 쇼트",
    "xj": "한계",
    "sj": "시장 가격",
    "xjwt": "주문 제한",
    "sjwt": "시장 가격",
    "pk": "핸디캡",
    "jg": "가격",
    "sl": "금액",
    "gg": "레버리지",
    "tzgg": "레버리지 조정",
    "ggbs": "레버리지",
    "mrl": "매입량",
    "ky": "이용 가능",
    "jye": "회전율",
    "dqwt": "대기 주문",
    "lswt": "커미션 이력",
    "ptwt": "통상 커미션",
    "dqwtmr": "현재 주문(매입)",
    "dqwtmc": "현재 주문(매도)    ",
    "hywt": "계약 커미션",
    "jj": "정보",
    "wtzl": "총",
    "wtjg": "커미션 가격",
    "ycjl": "완료된 거래 볼륨",
    "cjjj": "평균 거래 가격",
    "cd": "인출",
    "xd": "주문",
    "wqcj": "거래 완료",
    "ywc": "완료됨",
    "ycd": "인출됨",
    "zx": "선택 사항",
    "scjg": "시장 가격",
    "fhsj": "배포 시간",
    "fhsl": "발행 번호",
    "bps": "백서",
    "gw": "공식 웹사이트",
    "mrzd": "롱 매입",
    "mrpk": "쇼트 매입 ",
    "mczk": "쇼트 매도 ",
    "mcpd": "롱 매도",
    "mrkdkz": "오픈 매입(상승세)",
    "mrpkkz": "클로즈 매입(상승세)",
    "mckkkd": "오픈 매입(하락세)",
    "mcpdkd": "클로즈 매도(하락세)",
    "yxhy": "영구 계약",
    "dc": "롱 포지션",
    "syl": "수익률",
    "bzjl": "마진율",
    "tzbzj": "마진 조정",
    "zyzs": "수익을 올리고 손실은 멈추세요",
    "zhang": "금액",
    "qblx": "모든 유형",
    "qb": "모두",
    "ccjg": "포지션 가격",
    "ccsl": "포지션 수량",
    "yk": "수익 및 손실",
    "ccsj": "포지션 시간",
    "zy": "수익 올리기",
    "zs": "손실 멈추기",
    "zje": "총 금액",
    "kcs": "오픈 포지션 수량",
    "kcjg": "오픈 포지션 가격",
    "ss": "로트",
    "hand": "1 로트  =",
    "qx": "취소",
    "qr": "확인",
    "qbcd":"모든 주문 취소"
  },
  "bbjyNew":{
    "jylx": "유형",
    "jyze": "양"
  },
  "langNew3":{
    "bzxq": "움직이는 벽돌의 세부사항",
     "znbz": "AI 정량적 지능형 벽돌 이동",
     "apits": "전 세계 200개 이상의 거래소 API에 원활하게 연결",
     "jr": "가입",
     "gn": "함수",
     "lhjs": "피제수 정량화 소개",
     "jqrts": "로봇은 어떻게 작동하나요?",
     "sctj": "시장 통계",
     "scqk": "시장 상황",
     "jiaoge": "배달",
     "zhang": "일어나다",
     "die": "가을",
     "sz": "설정",
     "qbcp": "모든 제품",
     "jrlh": "AI 정량화에 참여하세요",
      "sywd": "위험 없음, 안정적인 수익",
      "bzbz": "암호화폐 유형"
  },
  "sztkmm": {
    "title": "인출 암호 설정",
    "dlmm": "로그인 암호 ",
    "dlmmts": "로그인 암호를 입력해 주십시오",
    "xmm": "새 암호",
    "mmts": "암호 길이 6자리",
    "qrmm": "암호 확인",
    "qr": "확인",
    "qd": "확인",
    "sztkts": "팁: 거래 암호를 설정하려면 보안 센터로 이동해 주십시오"
  },
  "bzhl": {
    "title": "배당금",
    "gz":"규칙",
    "tgdd": "에스크로우 주문",
    "zztgdzj": "수탁된 자금",
    "yjjrsy": "일일 예상",
    "ljsy": "총 수입",
    "tgzdd": "명령을 구금",
    "cljxcp": "전략적 캠페인 제품",
    "dbxe": "한계",
    "rsyl": "일일 수익률",
    "zq":"주문 주기",
    "qmr": "가서 구매하세요",
    "bbzhzc": "계정 자산",
    "zcc": "총자산(USDT)",
    "dd":"주문",
    "buy": "구매",
    "jxcp":"주요 제품",
    "ckdd": "주문 확인",
    "gd":"더 보기",
    "xzbzts": "간단하고 안전합니다. 배당금은 여러 통화로 선택할 수 있습니다.",
    "qtbz": "다른 동전",
    "dj": "레벨",
    "cjwt": "일반적인 문제",
    "ddsl": "주문 수량",
    "sl": "금액"
  },
  "bzhlgm": {
    "qtzq": "USDT 7일 주기",
    "rsyl": "일일 수익률",
    "lczq": "재무적 주기",
    "dbxe": "단일 한도 ",
    "pxsj": "배당금 지급 시기",
    "mr": "매일",
    "dqfh": "기한 만료 시 반환",
    "tgzj": "보호 예수 자본",
    "tqsh": "조기 상환",
    "yjsy": "예상 수입(USDT)",
    "kyzc": "이용 가능 자산(USDT)",
    "cpjs": "상품 소개",
    "tgje": "보호 예수 금액",
    "qsrtgje": "보호 예수 금액을 입력해 주십시오",
    "qb": "모두",
    "rm": "여기를 클릭하세요",
    "cpzq": "상품 주기",
    "gz": "규칙과 이자를 알아 두기"
  },
  "bzhlwdtg": {
    "title": "주문 상태",
    "tgz": "구금 중",
    "ywc": "완료",
    "ysh": "구원됨",
    "tgje": "보관 금액/보관 시간",
    "rsyl": "매일 돌아오는 쥐",
    "yhl": "이익을 얻었습니다",
    "xdsj": "주문 시간",
    "sh": "구원",
    "ddxq": "주문 세부정보",
    "ddh":"주문 번호 ",
    "syts": "남음",
    "ddztxq": "주문 상태 세부정보"
  },
  "langNew4":{
    "kp": "열리는",
    "zuoshou": "어제 받음",
    "zg": "제일 높은",
    "zd": "최저",
    "dqjg": "현재 가격",
    "pcjg": "종가",
    "gd": "미결 주문",
    "gdj": "보류 중인 주문 가격",
    "gdjg": "보류 중인 주문 가격",
    "xfbzj": "필요한 보증금: ",
    "ksrfw": "사용 가능한 입력 범위: ",
    "shou": "많이",
    "fdjyk": "유동 순이익 및 손실",
    "pcsl": "결산 수량",
    "cx": "취소",
    "qrpc": "포지션 청산 확인",
    "sx": "필터",
    "cz": "초기화",
    "zdl": "알고 있었다",
    "kccg": "성공적으로 포지션을 열었습니다!",
    "xzfx": "방향을 선택",
    "lx": "유형",
    "xgcc": "위치 수정",
    "szzyzs": "손절매 및 손절매 설정",
    "szhb": "암호화폐",
    "gjs": "금속",
    "yy": "조잡한",
    "jy": "거래",
    "gp": "재고",
    "jmhb": "암호화폐",
    "gdsj": "주문 대기 시간",
    "gdsl": "보류 중인 주문 수량",
    "fs": "time"
   },
   "deals": {
    "issue_time": "배포 시간",
    "issue_number": "발행 번호",
    "white_book": "백서",
    "weburl": "공식 웹사이트",
    "video_url": "비디오",
    "introduction": "정보",
    "onhand": "1로트 =",
    "position": "포지션",
    "leverorder": "레버리지 주문",
    "leverposition": "레버리지 포지션",
    "inputprice": "입력 가격",
    "inputmul": "입력 배수",
    "selectmul": "배수 선택",
    "onehand": "1로트 =",
    "hand": "거래 로트",
    "marketval": "시장 가치",
    "bond": "본드",
    "balance": "잔고",
    "type": "유형",
    "risk": "위험률",
    "total": "총 수익",
    "onekey": "원클릭 환금",
    "makemore": "(롱)",
    "makeless": "(쇼트)",
    "current": "대기 주문",
    "all": "모두",
    "weing": "수수료",
    "tding": "거래",
    "ping": "청산",
    "pied": "청산됨",
    "ceiled": "인출됨",
    "weprice": "커미션 가격",
    "oprice": "개시 가격",
    "nowprice": "현재 가격",
    "zyprice": "수익 가격 취하기",
    "zsprice": "손실 중단 가격",
    "canbond": "이용 가능 마진",
    "optime": "개시 시간",
    "pgtime": "청산 시간",
    "znum": "변환된 금액",
    "gprice": "야간 요금",
    "pcang": "클로즈",
    "revoke": "인출",
    "fee": "수수료",
    "you": "최적 시장 가격"
  },
  "zyzs": {
    "title": "수익을 올리고 손실은 멈추세요",
    "zy": "수익 올리기",
    "zs": "손실 멈추기",
    "qsrzyjg": "수익 올리기 가격을 입력해 주십시오",
    "qsrzsjg": "손실 멈추기 가격을 입력해 주십시오",
    "scjg": "시장 가격",
    "wxts": "미리 알림:",
    "qr": "확인"
  },
  "ssbt":{
    "ssbt":"세금 지원",
    "ssnhm":"사회보장번호",
    "qsrssnhm":"사회보장번호(SSN)를 입력하세요",
    "idzmz":"신분증 앞면 사진",
    "qscidzmz":"신분증 앞면 사진을 업로드해 주세요.",
    "dhfb":"송금 사본",
    "qscdhfb":"송금 사본을 업로드해 주세요.",
    "srlyfb":"소득원 사본",
    "qscsrlyfb":"소득원 사본을 업로드해 주세요.",
  },
  "newReg":{
    "sjh": "휴대전화",
    "yx": "이메일",
    "yqm": "초대 코드",
    "yqm2": "초대 코드(선택 사항)",
    "cjzh": "계정 만들기",
    "sysjhzyx": "휴대폰 번호/이메일로 등록",
    "sj": "휴대전화",
    "yhxy": "&lt;이용약관&gt;",
    "yhxy2": "및 &lt;이용약관&gt;을 읽었으며 이에 동의합니다.",
    "hmyzh": "아직 계정이 없습니까?",
    "qzc": "등록",
    "qbdl": "지갑 로그인",
    "qyqbfw": "지갑 앱을 사용해 접속하세요.",
    "dc": "로그 아웃"
  },
  "langNew5":{
    "dl":"로그인",
    "ljdz":"지갑 주소 연결",
    "srdz":"주소 입력",
    "ljqq":"연결 요청",
    "qq":"요청",
    "qb":"지갑",
    "ckyehhd":"잔액 및 활동 보기",
    "qqjypz":"거래 승인 요청",
    "cro":"크로노스",
    "jj":"거부",
    "lj":"연결",
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/hy.js